// extracted by mini-css-extract-plugin
export var active = "_1o-7";
export var backButton = "_1o-6";
export var collapseBar = "_1o-f";
export var collapseMode = "_1o-h";
export var dragHandle = "_1o-a";
export var dropdownIcon = "_1o-d";
export var hidden = "_1o-n";
export var iconContainer = "_1o-k";
export var iconSwapper = "_1o-m";
export var navItem = "_1o-4";
export var navItemIcon = "_1o-c";
export var navProfile = "_1o-5";
export var notificationDot = "_1o-l";
export var optionsContainer = "_1o-e";
export var primaryNav = "_1o-0";
export var primaryTab = "_1o-i";
export var secondaryNav = "_1o-1";
export var selected = "_1o-j";
export var settingsNav = "_1o-2";
export var settingsNavItems = "_1o-3";
export var show = "_1o-b";
export var sideNav = "_1o-g";
export var teamItem = "_1o-8";
export var userProfileItem = "_1o-9";